import React from "react";

import styles from "./style.module.scss";
import { translate } from "@helpers/translationObjectFormatter";
import { TranslationsObject } from "@genericTypes/sharedTypes";
import { useQuery } from "@tanstack/react-query";
import Left from "./logos/left";
import Right from "./logos/right";
import Independent from "./logos/independent";
import Simple from "./logos/simple";
import OnlyFact from "./logos/onlyFact";
import ConsProsIcon from "./logos/consProsIcon";
import GoldenLogo from "./logos/goldenLogo";
const WhySeveral = () => {
    const { data: translations } = useQuery<TranslationsObject>([
        "translations",
    ]);

    return (
        <section className={` lg:mt-44 mt-20 ${styles["mainContainer"]}`}>
            <div
                className={`lg:pt-24 pt-10  lg:pb-40 pb-20  ${styles["innerContainer"]}`}
            >
                <h2 className=" mb-4 font-extrabold lg:text-4xl lg:leading-9 text-2xl  w-fit mx-auto">
                    {`${translate(translations, "several_general_whyWord")}
                    Several.Com?`}
                </h2>
                <span className={styles["goldenLogo"]}>
                    <GoldenLogo />
                </span>
                <div className="lg:mt-24 mt-10">
                    <div className="flex justify-center ">
                        <Independent />
                    </div>
                    <div className="px-4 lg:px-0">
                        <h2>
                            {translate(
                                translations,
                                "several_aboutUsPage_WeAreIndependentTitle",
                            )}
                        </h2>
                        <p>
                            {translate(
                                translations,
                                "several_aboutUsPage_WeAreIndependentDescription",
                            )}
                        </p>
                    </div>
                </div>
                <span className="relative top-6">
                    <Left />
                </span>
                <div>
                    <div className="flex justify-center order-1 lg:order-2">
                        <OnlyFact />
                    </div>
                    <div className="lg:order-1 order-2 px-4 lg:px-0">
                        <h2>
                            {translate(
                                translations,
                                "several_aboutUsPage_OnlyFactBasedInformationTitle",
                            )}
                        </h2>
                        <p className="">
                            {translate(
                                translations,
                                "several_aboutUsPage_OnlyFactBasedInformationDescription",
                            )}
                        </p>
                    </div>
                </div>
                <span className="relative top-6">
                    <Right />
                </span>
                <div>
                    <div className="flex justify-center  h-[230px]  lg:h-[303px]  ">
                        <Simple />
                    </div>
                    <div className="px-4 lg:px-0">
                        <h2>
                            {translate(
                                translations,
                                "several_aboutUsPage_SimpleAndStraightforwardTitle",
                            )}
                        </h2>
                        <p>
                            {translate(
                                translations,
                                "several_aboutUsPage_SimpleAndStraightforwardDescription",
                            )}
                        </p>
                    </div>
                </div>
                <span className="relative top-7">
                    <Left />
                </span>
                <div>
                    <div className="flex justify-center order-1 lg:order-2 ">
                        <ConsProsIcon />
                    </div>
                    <div className="order-2 lg:order-1 px-4 lg:px-0">
                        <h2>
                            {translate(
                                translations,
                                "several_aboutUsPage_ConsBeforeProsTitle",
                            )}
                        </h2>
                        <p>
                            {translate(
                                translations,
                                "several_aboutUsPage_ConsBeforeProsDescription",
                            )}
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default WhySeveral;
